export default {
  row1 : [
  {
    column: "column1",
    columnWidth: "50%",
    rows: {
      row1: [
        {
          name: "exportUDFRemarksCcl",
          actionText: "Remarks-CCL",
          component: "textarea",
          height : 90,
          
        },
      ],
      row2: [
        {
          name: "exportUDFShippingLine",
          label: "Shipping Line",
          component: "text-field",
         
        },
      ],
      
      row3: [
        {
          name: "exportUDFBillNo",
          label: "Bill No",
          component: "text-field",
         
        },
      ],
      row4: [
        {
          name: "exportUDFFCLLCL",
          label: "FCL / LCL",
          component: "text-field",
          
        },
      ],
      row5: [
        {
          name: "exportUDFOverseasBill",
          label: "Overseas Bill",
          component: "text-field",
          
        },
      ],
      row6: [
        {
          name: "exportUDFGoJobNo",
          label: "@GO Job No",
          component: "text-field",
          
        },
      ],
      row7: [
        {
          name: "exportUDFGoDate",
          label: "@GO Date",
          component: "dateselector",
          width:"100%"
          
        },
      ],
      row8: [
        {
          name: "exportUDFBillDate",
          label: "Bill Date",
          component: "datetimeselector",
          width:"100%",
          
        },
      ],
      row9: [
        {
          name: "exportUDFBillNumber",
          label: "Bill No",
          component: "text-field",
          
        },
      ],
      row10: [
        {
          name: "exportUDFBillDT",
          label: "Bill DT",
         component: "datetimeselector",
         width:"100%"
         
        },
      ],
    },
  },
]
};
